import '../../abstracts/Mdg2StoreModuleFactory.js';
import { Mdg2EndpointStoreModuleFactory } from '../../abstracts/Mdg2EndpointStoreModuleFactory.js';
import '../../abstracts/Mdg2SubscriptionStoreModuleFactory.js';
import { baseMdg2EndpointModule } from '../../abstracts/Mdg2EndpointBaseModule.js';
import 'vue';
import 'lodash.set';

const DEFAULT_VERSION = "v1";
const DEFAULT_METHOD = "POST";
const DEFAULT_ROUTE = "/watchlist/modify";
const DEFAULT_TTL = 0;
const _WatchlistModifyModuleFactory = class extends Mdg2EndpointStoreModuleFactory {
  getModule() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const request = {
      method: (_b = (_a = this.options) == null ? void 0 : _a.method) != null ? _b : DEFAULT_METHOD,
      url: `/api/${(_d = (_c = this.options) == null ? void 0 : _c.version) != null ? _d : DEFAULT_VERSION}${(_f = (_e = this.options) == null ? void 0 : _e.route) != null ? _f : DEFAULT_ROUTE}`,
      ttl: (_h = (_g = this.options) == null ? void 0 : _g.ttl) != null ? _h : DEFAULT_TTL,
      options: {
        no_merge: true
      }
    };
    return baseMdg2EndpointModule(request, this.mdg2Client, this.logger);
  }
  getNameSpace() {
    return `${_WatchlistModifyModuleFactory.nameSpace}_${JSON.stringify(this.options)}`;
  }
};
let WatchlistModifyModuleFactory = _WatchlistModifyModuleFactory;
WatchlistModifyModuleFactory.nameSpace = "watchlistModifyModule";

export { WatchlistModifyModuleFactory };
